interface SparklineProps {
  values: (number | null)[];
  color: string;
  height?: number;
  width?: number;
}

/** Мини-тренд для стат-тайла: без осей и тултипа — просто форма динамики. */
export function Sparkline({ values, color, height = 36, width = 120 }: SparklineProps) {
  const present = values.filter((v): v is number => v != null);
  if (present.length < 2) return <div style={{ height, width }} />;

  const max = Math.max(...present);
  const min = Math.min(...present);
  const range = max - min || 1;
  const step = width / (values.length - 1);

  let d = '';
  let open = false;
  values.forEach((v, i) => {
    if (v == null) {
      open = false;
      return;
    }
    const x = i * step;
    const y = height - ((v - min) / range) * height;
    d += `${open ? 'L' : 'M'} ${x} ${y} `;
    open = true;
  });

  let lastIdx = -1;
  for (let i = values.length - 1; i >= 0; i--) {
    if (values[i] != null) {
      lastIdx = i;
      break;
    }
  }
  const lastVal = lastIdx >= 0 ? values[lastIdx] : null;
  const lastX = lastIdx * step;
  const lastY = lastVal != null ? height - ((lastVal - min) / range) * height : 0;

  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} style={{ overflow: 'visible' }}>
      <path d={d.trim()} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" opacity={0.85} />
      {lastVal != null ? <circle cx={lastX} cy={lastY} r={3} fill={color} /> : null}
    </svg>
  );
}
